var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"iframe",attrs:{"src":this.videoUrl,"title":"YouTube video player","frameborder":"0","allow":"accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }